export const GOVERNANCR_SCORE_TOOLTIP_SECTION_ID = 39;
export const DISSIDENT_VOTING_SUMMARY_TOOLTIP_SECTION_ID = 99;
export const GOVERNANCE_CORPORATE_DEFENSE_SCOREDATA_TOOL_TOOLTIP_SECTION_ID = 73;

export default {
  GOVERNANCR_SCORE_TOOLTIP_SECTION_ID,
  GOVERNANCE_CORPORATE_DEFENSE_SCOREDATA_TOOL_TOOLTIP_SECTION_ID,
  DISSIDENT_VOTING_SUMMARY_TOOLTIP_SECTION_ID,
};
